import { MutationTree } from 'vuex';
import { AccountsState } from './types';

export const mutations: MutationTree<AccountsState> = {
    pushAccounts:(state, data) => {
        state.accounts = state.accounts.concat(data)
    },
    setAccounts:(state, data) => {
        state.accounts = data
    },
    setAccountItem:(state, data) => {
        state.accountItem = data
    },
};